/* unplugin-vue-components disabled */import { render } from "./telephoneAssembly.vue?vue&type=template&id=0b8cb326&scoped=true"
import script from "./telephoneAssembly.vue?vue&type=script&lang=js"
export * from "./telephoneAssembly.vue?vue&type=script&lang=js"

import "./telephoneAssembly.vue?vue&type=style&index=0&id=0b8cb326&scoped=true&lang=css"

import exportComponent from "E:\\work\\weitu_land_page_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8cb326"]])

export default __exports__